import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import styles from '../../../style';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Button,
  Select,
  Input,
  CircularProgress
} from '@material-ui/core';
import { Check, CancelOutlined, AddCircleOutline } from '@material-ui/icons';

import validate from 'validate.js';
import schema from './schema';
import { connect } from 'react-redux';
import {
  getSystemCPTCodes,
  addSystemCPTCode,
  deleteSystemCPTCode
} from 'services/cpt/action';

const System = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      addSelectedCPT,
      deleteSelectedCPT,
      loadSystemCPT
    };
  });
  // const System = props => {
  const { classes, ehrID } = props;
  const [loading, setLoading] = useState(true);
  const [code, setCode] = React.useState([]);
  const [cptCodeMasterList, setCPTCodeMasterList] = React.useState([]);
  const [cptCode, setCPTCode] = React.useState([]);
  const [cptQuery, setCPTQuery] = React.useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const initialState = {
    code: '',
    description: '',
    keyid: ehrID,
    isValid: false,
    touched: {},
    errors: {}
  };
  const [values, setValues] = useState(initialState);

  useEffect(() => {
    loadSystemCPT();
  }, []);

  const loadSystemCPT = () => {
    setLoading(true);
    props.getSystemCPTCodes(ehrID).then(res => {
      if (res && res.data.length > 0) {
        setCPTCode(res.data);
        setCPTCodeMasterList(res.data);
        setLoading(false);
      }
    });
  };

  const addSingleCPT = () => {
    const codes = [];
    codes.push({
      code: values.code,
      description: values.description,
      keyid: values.keyid
    });
    if (values.isValid) {
      props.addSystemCPTCode(ehrID, codes).then(res => {
        if (res) {
          setEdit();
          props.getSystemCPTCodes(ehrID).then(res => {
            if (res && res.data.length > 0) {
              setCPTCodeMasterList(res.data);
              if (cptQuery !== '') {
                let searchResult = null;
                searchResult = findCPTs(res.data, cptQuery);
                setCPTCode(searchResult);
              } else {
                setCPTCode(res.data);
              }
            }
          });
          setValues(initialState);
        }
      });
    }
  };

  const _handleKeyDown = e => {
    if (e.key === 'Enter') {
      addSingleCPT();
    }
  };

  const handleChange = (field, value) => {
    if (field === 'cptQuery') {
      setCPTQuery(value);
      let searchResult = null;
      searchResult = findCPTs(cptCodeMasterList, value);
      setCPTCode(searchResult);
    } else {
      const newState = { ...values };
      newState[field] = value;
      newState.touched[field] = true;
      const errors = validate(newState, schema);
      newState.errors = errors || {};
      newState.isValid = errors ? false : true;
      setValues(newState);
    }
  };

  const findCPTs = (items, text) => {
    text = text.toLowerCase().split(' ');
    return items.filter(function(item) {
      return text.every(function(el) {
        return (
          (item.code && item.code.toLowerCase().indexOf(el) > -1) ||
          (item.description && item.description.toLowerCase().indexOf(el) > -1)
        );
      });
    });
  };

  const handleChangeMultiple = event => {
    const { options } = event.target;
    const value = [];
    const selectedVal = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
        selectedVal.push(
          cptCodeMasterList.filter(
            item => item.id === parseInt(options[i].value)
          )
        );
      }
    }
    setCode(value);
    props.setSelectedUserCodes(selectedVal, 'system');
  };

  const addSelectedCPT = async selectedCPT => {
    const codes = [];
    codes.push({
      code: values.code,
      description: values.description,
      keyid: values.keyid
    });
    if (selectedCPT.length > 0) {
      props.addSystemCPTCode(ehrID, selectedCPT).then(res => {
        if (res) {
          props.getSystemCPTCodes(ehrID).then(res => {
            if (res && res.data.length > 0) {
              setCPTCode(res.data);
              setCPTCodeMasterList(res.data);
            }
          });
        }
      });
    }
  };

  const deleteSelectedCPT = async selectedCPT => {
    const codes = [];
    codes.push({
      code: values.code,
      description: values.description,
      keyid: values.keyid
    });
    if (selectedCPT.length > 0) {
      props.deleteSystemCPTCode(ehrID, selectedCPT).then(res => {
        if (res) {
          props.getSystemCPTCodes(ehrID).then(res => {
            if (res && res.data.length > 0) {
              setCPTCode(res.data);
              setCPTCodeMasterList(res.data);
            }
          });
        }
      });
    }
  };

  const setEdit = () => {
    setIsEdit(!isEdit);
  };

  return (
    <div className={classes.templateWrap}>
      <div className={classes.templateHead}>
        <Typography>System CPT &amp; Descriptions</Typography>
      </div>

      <div className={classes.templateBody}>
        <div style={{ maxHeight: 'calc(100vh - 298px)' }}>
          <Table
            className={classes.templateTable}
            style={{ overflow: 'hidden' }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '100%' }}>
                  <TextField
                    className={[classes.textBox, classes.fullWidth]}
                    id="outlined-basic"
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline
                      }
                    }}
                    onChange={event =>
                      handleChange('cptQuery', event.target.value)
                    }
                    placeholder="Search system codes and descriptions"
                    value={cptQuery}
                    variant="outlined"
                  />
                </TableCell>
                <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>
                  {!isEdit ? (
                    <Button
                      className={classes.addButton}
                      color="primary"
                      onClick={() => setEdit()}
                      size="small"
                      variant="contained">
                      <AddCircleOutline />
                    </Button>
                  ) : (
                    <Button
                      className={classes.addButton}
                      color="primary"
                      onClick={() => setEdit()}
                      size="small"
                      style={{ backgroundColor: '#B9B9B9' }}
                      variant="contained">
                      <CancelOutlined />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            {isEdit ? ( 
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: '100%', whiteSpace: 'nowrap' }}>
                      <TextField
                        className={classes.textBox}
                        id="outlined-basic"
                        InputProps={{
                          classes: {
                            notchedOutline: classes.notchedOutline
                          }
                        }}
                        onChange={event =>
                          handleChange('code', event.target.value)
                        }
                        placeholder="Input Code"
                        style={{ width: 80 }}
                        value={values.code}
                        variant="outlined"
                      />
                      <TextField
                        className={classes.textBox}
                        id="outlined-basic"
                        InputProps={{
                          classes: {
                            notchedOutline: classes.notchedOutline
                          }
                        }}
                        onChange={event =>
                          handleChange('description', event.target.value)
                        }
                        onKeyPress={_handleKeyDown}
                        placeholder="Input Description"
                        style={{ width: 'calc(100% - 85px)', marginLeft: 5 }}
                        value={values.description}
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>
                      <IconButton
                        color="primary"
                        disabled={!values.isValid}
                        onClick={() => addSingleCPT()}
                        size="small"
                        style={{ marginLeft: -15, color: '#03A484' }}>
                        <Check />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead> 
            ) : null}
            <TableBody>
              <TableRow>
                <TableCell
                  colSpan={2}
                  style={{
                    borderColor: 'transparent',
                    height: 'calc(100vh - 400px)'
                  }}>
                  {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <CircularProgress size={24} />
                    </div>
                  ) : cptCode && cptCode.length > 0 ? (
                    <Select
                      className={classes.multiSel}
                      disabledUnderline
                      input={
                        <Input
                          classes={{
                            underline: classes.underline
                          }}
                        />
                      }
                      inputProps={{ size: '10' }}
                      multiple
                      native
                      onChange={handleChangeMultiple}
                      value={code}
                      variant="standard">
                      {cptCode && cptCode.length > 0
                        ? cptCode.map(cptcode => (
                            <option
                              code={cptcode.code}
                              description={cptcode.description}
                              key={cptcode.id}
                              value={cptcode.id}>
                              {cptcode.code} {cptcode.description}
                            </option>
                          ))
                        : null}
                    </Select>
                  ) : (
                    <Typography>
                      No records of system CPT &amp; descriptions
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
});

System.propTypes = {
  className: PropTypes.string
};

const mapDispatchToProps = {
  getSystemCPTCodes,
  addSystemCPTCode,
  deleteSystemCPTCode
};

const mapStateToProps = state => ({
  ehrID: state.profile && state.profile.ehrID,
  systemCPT: state.providers && state.cpt && state.cpt.systemCPT
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(withStyles(styles)(System));
